export default "__VITE_PUBLIC_ASSET__17dcbdf5__"